import { useTranslation } from "react-i18next";
import errorImg from "../../../assets/images/error.svg";
import RenewalHeader from "./RenewalHeader";
import { windowScroll } from "../../../helpers/shared/useNavigationEffects";
import { useEffect } from "react";

const PageNotFound = () => {
  const { t } = useTranslation("pages", { keyPrefix: "travel.payNow.notfound" });
  useEffect(() => {
    windowScroll();
  });
  return (
    <div className="flex flex-col justify-start min-h-[inherit]">
      <RenewalHeader />
      <div className="container-flow flex-grow  mt-6 lg:mt-40">
        <div className="flex">
          <div className="w-full lg:w-3/5 lg:pr-12">
            <h1 className="font-serif font-bold text-3xl md:text-4xl mb-3">{t("title")}</h1>
            <p className="mt-6 mb-8">{t("content")}</p>
            <p className="mt-6 mb-8">{t("content1")}</p>
          </div>
          <div className="w-2/5 hidden lg:block">
            <img src={errorImg} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
